// extracted by mini-css-extract-plugin
export default {"overlay":"TutorialOverlay_overlay__3x2ce","dim":"TutorialOverlay_dim__stf+L","hole":"TutorialOverlay_hole__Eybhs","ring":"TutorialOverlay_ring__PwsaW"};